import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import usuarioReducer from './usuarioReducer';
import recordarContrasenaReducer from "./recordarContrasenaReducer";
import pedidosReducer from "./pedidosReducer";
import rutasReducer from "./rutasReducer";
import wsgStatusReducer from "./wsgStatusReducer";
import pedidoRutaReducer from "./pedidoRutaReducer";

export default combineReducers({
  login: loginReducer,
  recordarcontrasena: recordarContrasenaReducer,
  pedidos: pedidosReducer,
  pedidoruta: pedidoRutaReducer,
  rutas: rutasReducer,
  wsgstatus: wsgStatusReducer,
  usuario: usuarioReducer
});
